"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getSummatedStyle(isHeader) {
    if (isHeader === void 0) { isHeader = false; }
    return {
        color: '#172B4D',
        backgroundColor: '#DFE1E5',
        fontFamily: '-apple-system, BlinkMacSystemFont, "San Francisco", "Segoe UI", "Roboto", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        fontSize: isHeader ? '16px' : '13px',
        fontWeight: 'bold',
        borderRadius: 4,
        padding: '2px 4px',
        marginLeft: '4px',
    };
}
exports.default = getSummatedStyle;
//# sourceMappingURL=SummatedComponentStyle.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/components/SummatedComponentStyle.js
// module id = 62
// module chunks = 0